exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#melon[data-v-6460faf2]{background:var(--theme-color)}", ""]);

// exports
